namespace JupitersChoice {
    export class ResponseHelper {

        @inject('BetModel') _betModel: Sapphire.BetModel;

        getLockedReels(lockedWithPreviousReelData: any): any {
            var lockedReels = [];

            lockedWithPreviousReelData.forEach((bool, idx) => {
                if (bool) {
                    lockedReels.push(idx);
                }
            });

            if (lockedReels.length > 0) {
                lockedReels.unshift(lockedReels[0] - 1);
            }

            return lockedReels;
        }

        getLastReelIndexWithWin(winnings: any[]): number {
            var lastReelIdxWithWin = 0;
            winnings.forEach(winning => {
                winning[3].forEach(position => {
                    if (position.x > lastReelIdxWithWin) {
                        lastReelIdxWithWin = position.x;
                    }

                })
            });

            return lastReelIdxWithWin;
        }

        getReelIndexesWhichContainWins(winnings: any[]): number[] {
            var indexes = [];

            winnings.forEach(winning => {
                winning[3].forEach(position => {
                    indexes.push(position.x);
                })
            });

            // filter out any dupes
            indexes = indexes.filter((x, i, a) => a.indexOf(x) == i);

            return indexes;
        }

        getWinAmountFromCurrentSpin(winnings: any[]): number {
            var amount = 0;

            winnings.forEach(winning => {
                amount += winning[2];
            });

            return amount
        }

        hasBaseGameWinnings(winnings: any[]): boolean {
            var hasBaseGameWinnings = false;

            if (winnings.length > 0) {
                hasBaseGameWinnings = true;
            }

            return hasBaseGameWinnings
        }

        hasMegaHit(winnings: any[]): boolean {
            const winAmount = this.getWinAmountFromCurrentSpin(winnings);
            const megaHitThreshold = this._betModel.getCurrentBet() * 25;
            var hasMegaHit = false;

            if (winAmount >= megaHitThreshold) {
                hasMegaHit = true;
            }

            return hasMegaHit;
        }
    }
}